import angular from 'angular';
import { IAlteracaoFoto } from '../models/alteracaofoto.model';
import { Usuario } from '../../../../core/usuario/models/usuario-model';
import { ITrabalhador } from '../../../Trabalhadores/models/trabalhador.model';
import { IWorkflowAcao, IWorkflowAcaoEnviar } from '../../../Workflow/models/workflow.acao.model';
import { MeurhAlteracaoFotoService } from '../alteracaofoto.service';
import { MeurhSolicitacoes } from '../../Solicitacoes/services/solicitacoes.service';
import { ModalConfirmService } from '../../../../shared/components/modal-confirm/modal.confirm.service';
import { WorkflowService } from '../../../Workflow/workflow.service';
import { WorkflowOldModalService } from '../../../Workflow/modais/oldModal/workflow.old.service';
import { WorkflowDefaultModalService } from '../../../Workflow/modais/defaultModal/workflow.default.service';
import { WorkflowCommentModalService } from '../../../Workflow/modais/commentModal/workflow.comment.service';
import { WorkflowDynamicModalService } from '../../../Workflow/modais/dynamicModal/workflow.dynamic.service';
import { applyNsjTableInlineMobileLabels, buildNsjTableInlineMobileLabel } from '../../../../utils/nsj-table';

type IAlteracaoFotoFilters = {
    lotacao: { lotacao: string; } | null;
	trabalhador: { trabalhador: string } | null;
	situacao: string | null;
    tipoColaborador: string | null;
    origem: string | null;
};

export class MeurhAlteracaoFotoIndexController {

    static $inject = [
        '$scope',
        '$rootScope',
        '$state',
        'NewToaster',
        'MeurhAlteracaoFotoService',
        'MeurhSolicitacoes',
        'ModalConfirmService',
        'WorkflowService',
        'WorkflowOldModalService',
        'WorkflowDefaultModalService',
        'WorkflowCommentModalService',
        'WorkflowDynamicModalService',
    ];

    public entities: IAlteracaoFoto[] = [];
    public filters: IAlteracaoFotoFilters = {
        lotacao: null,
        trabalhador: null,
        situacao: '',
        tipoColaborador: null,
        origem: null
    };
    public busy = false;

    public fields = applyNsjTableInlineMobileLabels([
        {
            value: 'trabalhadorobj.codigo',
            label: 'Matrícula',
            type: 'string',
            style: 'title',
            copy: '',
        }, {
            value: 'trabalhadorobj.nome',
            label: 'Colaborador',
            type: 'string',
            style: 'title',
            copy: '',
        }, {
            value: 'created_at',
            label: 'Enviado em',
            type: 'date',
            style: 'title',
            copy: '',
        }, {
            value: 'situacao',
            label: 'Situação',
            type: 'string',
            style: 'title',
            copy: '',
            customCollumnHtml: () => {
				let someHtmlVar = `
                    <label
                        ng-if="!tableRowEntity.wkf_estado"
                        class="label {{tableRowEntity.situacao | situacaoSolicitacaoClassEnum}}"
                    >
                        {{tableRowEntity.situacao | situacaoSolicitacaoEnum}}
                    </label>
                    <label
                        ng-if="tableRowEntity.wkf_estado"
                        class="label {{tableRowEntity.situacao | situacaoSolicitacaoClassEnum}}"
                    >
                        {{ tableRowEntity.wkf_estado }}
                    </label>
              	`;
			  return someHtmlVar;
            },
        }, {
            value: 'solicitacao',
			label: 'Ações',
			type: 'div',
			style: 'title',
			copy: '',
            customCollumnScope: {
				visualizarAlteracao: (entity: IAlteracaoFoto) => {
                    this.busy = true;
                    this.$state.go('meurh_alteracaofoto_show', {
                        solicitacao: entity.solicitacao
                    });
                },
				cancelarAlteracao: (entity: IAlteracaoFoto) => {
					this.modalCancelar(entity);
                },
                acionarWorkflow: (acao: IWorkflowAcao, solicitacao: string, trabalhador: ITrabalhador) => {
                    this.iniciarAcaoWorkflow(acao, solicitacao, trabalhador);
                }
            },
            customLabelHtml: buildNsjTableInlineMobileLabel('Ações', { showOnMobile: false }),
			customCollumnHtml: () => {
				let someHtmlVar = `
					<div class="display-flex justify-content-center justify-content-end-md">
						<nsj-button-dropdown
							border="none"
							split="false"
							size="sm"
							icon="fas fa-ellipsis-v"
							dropdown-direction="right"
							class="menuEllipsis"
                            ng-if="(tableRowEntity.situacao === 0 &&
                                (tableRowEntity.created_by.email === '${this.$rootScope.usuario.email}')) ||
                                (tableRowEntity._acoes && tableRowEntity._acoes.length)"
						>
							<item-dropdown
								item-label="Visualizar"
								ng-click="customCollumnScope.visualizarAlteracao(tableRowEntity)"
							></item-dropdown>
							<item-dropdown
                                ng-if="tableRowEntity.situacao === 0 &&
                                    (tableRowEntity.created_by.email === '${this.$rootScope.usuario.email}')"
								item-label="Cancelar alteração"
								ng-click="customCollumnScope.cancelarAlteracao(tableRowEntity)"
							></item-dropdown>
                            <item-dropdown
                                ng-repeat="acao in tableRowEntity._acoes"
								item-label="{{acao.title}}"
								ng-click="customCollumnScope.acionarWorkflow(
                                    acao,
                                    tableRowEntity.solicitacao,
                                    tableRowEntity.trabalhadorobj
                                )"
							></item-dropdown>
						</nsj-button-dropdown>
                        <a
                            class="btn btn-tertiary btn-sm"
                            ng-click="customCollumnScope.visualizarAlteracao(tableRowEntity)"
                            ng-if="!(
                                (tableRowEntity.situacao === 0 &&
                                (tableRowEntity.created_by.email === '${this.$rootScope.usuario.email}')) ||
                                (tableRowEntity._acoes && tableRowEntity._acoes.length)
                            )"
                        >
                            Visualizar
                        </a>
					</div>
              	`;
			  return someHtmlVar;
            },
        }
    ]);

    constructor (
		public $scope: angular.IScope,
        public $rootScope: angular.IRootScopeService & {
            usuario: Usuario,
            temPermissao: (arg: string) => boolean,
            liberadoTela: (arg: string) => boolean
        },
		public $state: angular.ui.IStateService,
        public NewToaster: { pop: Function },
        public MeurhAlteracaoFotoService: MeurhAlteracaoFotoService,
        public MeurhSolicitacoes: MeurhSolicitacoes,
        public ModalConfirmService: ModalConfirmService,
        public WorkflowService: WorkflowService,
        public WorkflowOldModalService: WorkflowOldModalService,
        public WorkflowDefaultModalService: WorkflowDefaultModalService,
        public WorkflowCommentModalService: WorkflowCommentModalService,
        public WorkflowDynamicModalService: WorkflowDynamicModalService,
	) {
        if (
            !this.$rootScope.temPermissao('visualizar_alteracaofoto') ||
            !this.$rootScope.liberadoTela('LIBERAR_MEURH_SOLICITACAO_ALT_FOTO')
        ) {
            $state.go('dp');
        }

        this.filterReload();

        $scope.$on('meurh_solicitacoesalteracoesfoto_loaded', (event, args: IAlteracaoFoto[]) => {
            this.entities = args;
        });
    }

    filterReload() {
        const constructor = {};

        if (!this.valorExiste(this.filters.lotacao)) {
			this.filters.lotacao = null;
        } else {
            constructor['lotacao'] = this.filters.lotacao?.lotacao;
        }

        if (!this.valorExiste(this.filters.trabalhador)) {
			this.filters.trabalhador = null;
        } else {
            constructor['trabalhador'] = this.filters.trabalhador?.trabalhador;
        }

        if (!this.valorExiste(this.filters.tipoColaborador)) {
			this.filters.tipoColaborador = null;
        } else {
            constructor['trabalhador_tipo'] = this.filters.tipoColaborador;
        }

		if (!this.valorExiste(this.filters.situacao)) {
			this.filters.situacao = null;
        } else {
            constructor['situacao'] = this.filters.situacao;
        }

        if (!this.valorExiste(this.filters.origem)) {
			this.filters.origem = null;
        } else {
            constructor['origem'] = this.filters.origem;
        }

        this.entities = [];
		this.MeurhAlteracaoFotoService.constructors = constructor;
        this.MeurhAlteracaoFotoService.reload();
    }

    loadMore(): void {
        this.MeurhAlteracaoFotoService.loadMore();
    }

    modalCancelar(entity: IAlteracaoFoto): void {
        const customText = {
            title: 'Cancelar',
            subtitle: 'Você está prestes a cancelar a solicitação de alteração de foto de',
            confirmText: 'Após o cancelamento, não será possível desfazer. Deseja continuar?',
            confirmTextNum: entity.trabalhadorobj.nome,
            closeButton: 'Voltar',
            confirmButton: 'Cancelar solicitação',
        };
        const confirm = this.ModalConfirmService.openCancelar(entity, 'Solicitação de alteração de foto', customText);
        confirm.result.then((entity: IAlteracaoFoto) => {
            this.cancelar(entity);
        }).catch(() => {/**/});
    }

    cancelar(entity: IAlteracaoFoto) {
        this.busy = true;
        this.MeurhSolicitacoes.cancelar(entity).then(() => {
            this.NewToaster.pop({
                type: 'success',
                title: 'A Solicitação de alteração de foto foi cancelada com sucesso.'
            });
            this.filterReload();
        }).catch((response: any) => {
            let error = 'Ocorreu um erro ao cancelar solicitação de foto.';
            if (response.data?.message) {
                error = response.data.message;
            }
            this.NewToaster.pop({
                type: 'error',
                title: error
            });
        }).finally(() => {
            this.busy = false;
        });
    }

    public iniciarAcaoWorkflow(acao: IWorkflowAcao, solicitacao: string, trabalhador: ITrabalhador) {
        const acaoEnviarObj: IWorkflowAcaoEnviar = {
            codigoAcao: acao.code,
            titulo: acao.title,
            descricao: acao.description,
            requiredcomment: acao.requiredcomment === null ? false : acao.requiredcomment,
            id: solicitacao,
            dataprorrogacaocontrato: acao.dataprorrogacaocontrato,
        };

        if (!acao.modal && !acao.requiredcomment) {
            this.WorkflowService.config(solicitacao, 'meurh_solicitacoesalterecoesfoto_');
            this.executarAcaoWorkflow(acaoEnviarObj);
            return;
        }

        const confirm = this.getModalWorkflow(acao, trabalhador);

        confirm.result.then((acao: IWorkflowAcao) => {
            this.WorkflowService.config(solicitacao, 'meurh_solicitacoesalterecoesfoto_');

            if (acao.comentario) {
                acaoEnviarObj.comentario = acao.comentario;
            }

            this.executarAcaoWorkflow(acaoEnviarObj);
        }).catch((error: any) => {
            acao.comentario = '';
            if (error !== 'backdrop click' && error !== 'fechar' && error !== 'escape key press') {
                this.NewToaster.pop({
                    type: 'error',
                    title: error,
                });
            }
        });
    }

    public executarAcaoWorkflow(acao: IWorkflowAcaoEnviar) {
        this.busy = true;
        this.WorkflowService.executarAcao(acao).then(() => {
            this.NewToaster.pop({
                type: 'success',
                title: 'Sucesso ao ' + acao.descricao,
            });
            this.filterReload();
        }).catch(() => {
            this.NewToaster.pop({
                type: 'error',
                title: 'Erro ao ' + acao.descricao,
            });
        }).finally(() => {
            this.busy = false;
        });
    }

    public getModalWorkflow(acao: IWorkflowAcao, trabalhador: ITrabalhador) {
        if (!acao.modal && acao.requiredcomment) {
            return this.WorkflowOldModalService.open(acao, trabalhador);
        }
        if (acao.requiredconfirmation) {
            return this.WorkflowDefaultModalService.open(acao, trabalhador);
        }
        if (acao.modal?.comentario) {
            return this.WorkflowCommentModalService.open(acao, trabalhador);
        }
        return this.WorkflowDynamicModalService.open(acao, trabalhador);
    }

    private valorExiste(valor: any): boolean {
		return valor !== '' && valor !== undefined && valor !== null ? true : false;
	}
}
